<template>
  <div>
    <div>
      <ChapterHead>
        <span>患儿编号：{{ info.childId }}</span>
        <span slot="extra">
          <el-button type="primary" size="small" icon="el-icon-back" @click="back" style="width: 86px;">返回</el-button>
        </span>
      </ChapterHead>
      <el-row>
        <el-col :span="3" class="avatar-view">
          <div class="demo-image__preview" style="margin-top: 2vw; min-width: 100px; min-height: 100px">
            <el-image v-if='childAvatar'
                      style="width: 100px; height: 100px; border-radius:50%"
                      :src="childAvatar ? childAvatar : '/static/default-avatar.png'"
                      :preview-src-list="[childAvatar ? childAvatar : '/static/default-avatar.png']">
            </el-image>
          </div>
          <!-- <div style="width: 100%;text-align: left;margin-top: 10px"  v-if="labelsList.length>0">相关标签：</div>
          <el-card class="box-card"  v-if="labelsList.length>0" :md="20">
            <el-tag size="mini" v-for="(item,index) in labelsList" :key="index" style="margin: 0 2px;" effect="dark"
                    type="info">{{ item }}</el-tag>
          </el-card> -->
<!--          <el-avatar-->
<!--            shape="circle"-->
<!--            style="margin-top: 2vw; min-width: 100px; min-height: 100px"-->
<!--            size="large"-->
<!--            class="avatar"-->
<!--            :src="childAvatar ? childAvatar : '/static/default-avatar.png'"-->
<!--          ></el-avatar>-->
        </el-col>
        <el-col :span="21">
          <el-form :inline="true">
            <el-row>
              <el-col :span="6">
                <el-form-item label="患儿姓名">
                  <el-input size="small" type="text" disabled v-model="info.childName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别">
                  <el-input size="small" type="text" disabled v-model="info.sexText"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="身份证">
                  <el-radio-group v-model="info.hasIdNumber">
                    <el-radio disabled :label="1">有</el-radio>
                    <el-radio disabled :label="0">无</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="身份证号">
                  <el-input size="small" type="text" disabled :value="info.hasIdNumber == 1 ? info.idNumber : '-'"
                  ></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="出生日期">
                  <el-input size="small" type="text" disabled v-model="birthday"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="民族">
                  <el-input size="small" type="text" disabled :value="info.nationText || '-'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                  <el-form-item label="监护人电话">
                    <el-input type="text" size="small" disabled :value="info.guardPhone||'-'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="其他电话">
                    <el-input type="text" size="small" disabled :value="info.guardOtherPhone||'-'"></el-input>
                  </el-form-item>
                </el-col>
              <el-col :span="12">
                <el-form-item label="户口所在地">
                  <el-input size="small" type="text" disabled :value="info.provinceText ? info.provinceText + ' / ' + info.cityText + ' / ' + info.countyText : '-'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址">
                  <el-input size="small" type="text" :rows="2" disabled :value="info.fullAddr || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="常住地址">
                  <el-input size="small" type="text" :rows="2" disabled :value="info.liveAddr || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="微信号">
                  <el-input size="small" type="text" disabled :value="info.guardWechat || '-'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item  label="登录手机号">
                  <el-input size="small" type="text" disabled :value="info.loginAccount||'-'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="6">
                <el-form-item label="支付宝姓名">
                  <el-input type="text" size="small" disabled  :value="info.loginUserName || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="支付宝身份证">
                  <el-input type="text" size="small" disabled  :value="info.loginIdNumber || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="支付宝UID">
                  <el-input  type="text" size="small" disabled  :value="info.loginChannelText=='支付宝' ? (info.OpenIdAli || '-') : '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="与患儿关系">
                  <el-input type="text" size="small" disabled  :value="info.loginRelationText || '-'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="6">
                <el-form-item label="住院号">
                  <el-input type="text" size="small" disabled  :value="info.inHospitalNoSet || '-'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <ChapterHead>
        <span>救助金额（元）</span>
      </ChapterHead>
        <el-form :inline="true">
          <el-row>
            <el-col style="width: calc(100% / 24 * 3 + 110px)">
              <el-form-item  label="已救助金额" prop="totalHelpAmount">
                <el-input size="small" disabled :value="hospitalMoneyInfo.totalHelpAmount" ></el-input>
              </el-form-item>
            </el-col>
            <el-col  style="width: calc((100% / 24 * 21) / 4)">
              <el-form-item  label="血液病剩余" prop="totalAngleOutlayAmount">
                <el-input size="small" disabled  :value="hospitalMoneyInfo.totalAngleOutlayAmount == 0 ? 0 : (hospitalMoneyInfo.totalAngleOutlayAmount || '-')">
                  <template v-if="hospitalMoneyInfo.allowAngelOutlay == 0 && hospitalMoneyInfo.totalAngleOutlayAmount > 0" slot="suffix">
                    <i class="el-icon-warning" style="color: red;" title="审核时间超过一年或已禁止新增费用。"></i>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      <ChapterHead>
        <span>申请信息</span>
        <span slot="extra">
          <el-button type="primary" size="small" @click="openNewDialog" style="width: 86px;">新增病种</el-button>
        </span>
      </ChapterHead>
      <el-table :data="tableData" v-loading="loading" style="width: 100%" :class="tableData && tableData.length > 1 ? '' : 'applyTable'">
        <el-table-column label="申请编号" fixed="left" width="150">
          <template slot-scope="scope">
            <span class="link" @click="openDetail(scope.row)">
              <span v-if="scope.row.outlayType == '2' && scope.row.applyType == 1">{{scope.row.specialPatientId}}</span>
              <span v-else>{{scope.row.helpId}}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="submitTime" width="100">
          <template v-slot="scope">
            {{ scope.row.submitTime ? parseTime(scope.row.submitTime, '{y}-{m}-{d}') : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="reqModeText"  width="80" label="申请方式"></el-table-column>
        <el-table-column prop="hospitalName" v-if="isHospitalstatus==='false'" width="180" label="救助医院">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.hospitalName" placement="bottom">
              <span class="two-line">{{ scope.row.hospitalName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="diseasesNameSet" min-width="160"  label="病种">
          <template slot-scope="scope">
            <TableCellWordBreak v-if="scope.row.diseasesNameSet" :content="scope.row.diseasesNameSet"></TableCellWordBreak>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="isSpecialPatient" width="50" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.applyType == 2">补款</span>
            <span v-else-if="scope.row.applyType == 3">退款</span>
            <span v-else>{{scope.row.isSpecialPatient==1 ? '特患' : '普通' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="期次" width="60">
          <template slot-scope="scope">
            {{ scope.row.curStages + "/" + (scope.row.initialProject == 'AY1002' ? "-" : (scope.row.totalStages || '-')) }}
          </template>
        </el-table-column>
        <el-table-column prop="helpStatusText" width="80" label="救助状态">
          <template slot-scope="scope">
            <span v-if="scope.row.apprStatus == '5'">审核中</span>
          <span v-else :class="scope.row.apprStatus == 3 ? 'warning-text' : ''">{{scope.row.apprStatusText || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核时间" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.apprStatus == '5'">-</span>
          <span v-else>{{scope.row.apprTime ? parseTime(scope.row.apprTime, '{y}-{m}-{d}') : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inHospitalNo" label="住院号" minWidth="130px">
          <template slot-scope="scope">
            {{ scope.row.inHospitalNo || '-' }}
          </template>
        </el-table-column>
	      <el-table-column label="入院时间" width="100" v-if="otherInfo.isShowInHospitalTime == 1">
		      <template slot-scope="scope">
			      <span>{{scope.row.inHospitalTime ? parseTime(scope.row.inHospitalTime, '{y}-{m}-{d}') : '-'}}</span>
		      </template>
	      </el-table-column>
        <el-table-column prop="outlayId" label="费用编号" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.applyType > 1">{{ scope.row.outlayId }}</span>
            <span class="link" v-else-if="scope.row.outlayId" @click="openOutlayDialog(scope.row)">
              {{ scope.row.outlayId }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="helpAmount" label="金额" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.helpAmount ? parseFloat(scope.row.helpAmount || 0).toFixed(2) : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="outlayStatusText" label="费用状态" width="80">
          <template slot-scope="scope">
            {{ scope.row.applyType == 1 && scope.row.outlayStatusText ? scope.row.outlayStatusText : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="outlayType" label="费用类型" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.outlayType == 1">治疗费用</span>
            <span v-else-if="scope.row.outlayType == 2">检查费用</span>
            <span v-else-if="scope.row.applyType == 2">补款费用</span>
            <span v-else-if="scope.row.applyType == 3">退款费用</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="protocolId" label="协议编号" width="130">
          <template slot-scope="scope">
            <TableCellWordBreak v-if="scope.row.protocolId && (scope.row.publishStatus == 2 || scope.row.applyType != 2)" :content="scope.row.protocolId">
              <span class="link" @click="openAgreeDialog(scope.row)">{{scope.row.protocolId}}</span>
            </TableCellWordBreak>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="protocolStatusText" label="协议状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.applyType == 2 && scope.row.publishStatus != 2">待生成</span>
            <span v-else>{{scope.row.protocolStatusText || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="protocolStatusText" label="操作" width="95" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.outlayType == 1 && scope.row.curStages == 1 && scope.row.curMaxStages < scope.row.totalStages && scope.row.initialProject != 'AY1002'"
              @click="openFqDialog(scope.row)"
              type="primary"
              plain
              :disabled="scope.row.apprStatus != 2"
              :placeholder="scope.row.apprStatus != 2 ? '救助申请没有审核通过！' : ''"
              size="mini">
              新增分期
            </el-button>
            <span v-else>-</span>
            <!-- <el-button
              v-if="scope.row.outlayType == 1 && scope.row.curStages == 1 && scope.row.initialProject == 'AY1002'"
              @click="openMoneyInputDialog(scope.row)"
              type="primary"
              plain
              :disabled="scope.row.apprStatus != 2"
              :placeholder="scope.row.apprStatus != 2 ? '救助申请没有审核通过！' : ''"
              size="mini">
              新增费用
            </el-button> -->
            <!-- <span v-if="scope.row.curStages > 1 || (scope.row.curStages == 1 && scope.row.curMaxStages == scope.row.totalStages && scope.row.initialProject != 'AY1002')">-</span> -->
          </template>
        </el-table-column>
      </el-table>
      <ChapterHead>
        <span>备注信息</span>
      </ChapterHead>
      <div>
        <el-form :model="info" :inline="true">
          <el-row style="margin-bottom: 20px;">
            <el-col style="width: 56%">
                <el-input
                  size="small"
                  type="textarea"
                  v-model="otherInfo.remark"
                  disabled
                  :rows="3">
                </el-input>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <ChildDiseasesAdd
      v-if="newDialog"
      :visible="newDialog"
      :childUid="info.childUid"
      :hospitalId="otherInfo.hospitalId"
      @success="childDiseasesAddSuccess"
      @close="newDialog = false">
    </ChildDiseasesAdd>
    <HelpStagesAdd
      v-if="fqDialog"
      :visible="fqDialog"
      :helpId="newFqData.helpId"
      :helpReqId="newFqData.helpReqId"
      @success="childDiseasesAddSuccess"
      @close="fqDialog = false">
    </HelpStagesAdd>
    <HelpOutlayAdd
      v-if="moneyInputDialog"
      :visible="moneyInputDialog"
      :helpId="newFqData.helpId"
      :outlayId="newFqData.outlayId"
      :helpReqId="newFqData.helpReqId"
      @success="childDiseasesAddSuccess"
      @close="moneyInputDialog = false">
    </HelpOutlayAdd>
    <ProtocolDetailDialog
      :dialogVisible.sync="agreeDialog"
      v-if="agreeDialog"
      :protocolId="proId"
    ></ProtocolDetailDialog>
    <HelpDetailDialog
      :visible="detailJzDialog"
      v-if="detailJzDialog"
      :outlayId="chooseData.outlayId"
      :helpId="chooseData.helpId"
      :helpData="chooseData"
      @close="detailJzDialog = false">
    </HelpDetailDialog>
    <el-dialog
      title="费用详情"
      v-if="outlayDetailVisible"
      :visible.sync="outlayDetailVisible"
      @close="outlayDetailVisible = false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="1300px">
      <el-tabs v-if="dialogVisible" v-model="dialogActiveName">
        <el-tab-pane label="费用信息" name="outlayInfo">
          <CureOutlayDetail
            v-if="outlayRowData.outlayType == '1'"
            :readOnly="true"
            :showCase="false"
            :belongProject="outlayRowData.initialProject"
            :outlayId="outlayRowData.outlayId"
            :helpReqId="outlayRowData.helpReqId">
          </CureOutlayDetail>
          <CheckOutlayDetail v-else :recordId="outlayRowData.outlayId" :disabled="true"></CheckOutlayDetail>
        </el-tab-pane>
        <el-tab-pane label="审核记录" name="outlayHistory">
          <OutlayHistory v-if="dialogActiveName == 'outlayHistory'" :outlayId="outlayRowData.outlayId"></OutlayHistory>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import ChapterHead from "@/components/business/ChapterHead";
import TableCellWordBreak from "@/components/business/TableCellWordBreak";
import ChildDiseasesAdd from "../manage/ChildDiseasesAdd";
import HelpStagesAdd from "../manage/HelpStagesAdd";
import HelpOutlayAdd from "../manage/HelpOutlayAdd";
import CureOutlayDetail from "@/pages/outlay/cure/CureOutlayDetail";
import CheckOutlayDetail from "@/pages/outlay/check/CheckOutlayDetail";
import HelpDetailDialog from './HelpDetailDialog';
import ProtocolDetailDialog from './ProtocolDetailDialog';
import OutlayHistory from '@/pages/outlay/view/OutlayHistory'

import MsgCodeInput from "@/components/business/MsgCodeInput";
import {
  getHelpStagesDataByIdApi,
  getDataListByCondFqNoPaging,
  getDataWithHospitalByIdFq,
  getOutlayDataById,
  totalAngleOutlayAmount,
  getAngleRemainingAmount,
  getAngleRemainingAmountByReqId,
  getGrantedDiseasesTreeApi,
  getChildabels,
  sendCaptchaApi,
  getChildInfo,
  downFileApi,
  getOutlayListByCondNoPaging,
  getFileListByIds
} from "@/util/api";
import moment from "moment";
export default {
  components: {
    ChapterHead,
    TableCellWordBreak,
    ChildDiseasesAdd,
    HelpOutlayAdd,
    HelpStagesAdd,
    HelpDetailDialog,
    ProtocolDetailDialog,
    CureOutlayDetail,
    CheckOutlayDetail,
    MsgCodeInput,
    OutlayHistory
  },
  data() {
    return {
      otherInfo: {},
      childAvatar: "", //患儿头像
      birthday: "",
      tableData: [],
      hospitalMoneyInfo: {},
      isDai: 0, //是否是代申请
      outlayDetailVisible: false,
      outlayRowData: {},
      newRequestDialog: false,
      newRequestData: {},
      isHospitalstatus:false,
      loading: false,
      outlayId: "",
      dialogImageUrl: "",
      disabled: false,
      newDialog: false,
      proId: "",
      labelsList: [],
      dialogForm: {},
      fqDialog: false,
      fqForm: {},
      moneyInputDialog: false,
      agreeDialog: false,
      detailJzDialog: false,
      detailTxDialog: false,
      moneyData: {},
      detailTsDialog: false,
      info: {},
      chooseHelpId: "",
      choosehelpReqId: "",
      chooseData: {},
      diseaseOptions: [],
      outlay_state: [],
      codeFlag: false,
      newFqData: {},
      dialogActiveName: 'outlayInfo',
      dialogVisible: false,
     /* xq:"xiangqing",*/
    };
  },
  created() {
    this.uid = this.$route.query.uid;
    this.queryDetail(this.$route.query.helpId);
    // this.getChildabels(this.$route.query.uid)
    this.getHelpStagesDataByIdApi(this.$route.query.helpId);
    this.getDataWithHospital(this.$route.query.helpId)
    this.isHospitalstatus = window.localStorage.getItem("hospAccount");
  },
  methods: {
    getHelpStagesDataByIdApi(id) {
      getHelpStagesDataByIdApi({
        helpId: id,
      }).then((res) => {
        if (res.msgCode == 200) {
          this.otherInfo = res.responseData;
        }
      });
    },
    getDataWithHospital(id){
      getDataWithHospitalByIdFq({helpId:id}).then(res=>{
        if (res.msgCode == 200) {
          let dat = res.responseData;
          this.hospitalMoneyInfo.totalHelpAmount = parseFloat(dat.totalHelpAmount || 0).toFixed(2);
          this.hospitalMoneyInfo.hasAmount = dat.allowAngelOutlay == 0 ? 0 : (dat.isOutlayTimeout || 0);
          this.$forceUpdate();
        }
      })
    },

    childDiseasesAddSuccess () {
      this.queryList(this.info.childUid);
    },
    back() {
      this.$router.push({ path: this.$route.meta.path + '?q=' + new Date().getTime() });
    },
    makeDate(time) {
      let _date = new Date(time);
      var y = _date.getFullYear();
      var m = _date.getMonth() + 1;
      var d = _date.getDate();
      if (m < 10) m = "0" + m;
      if (d < 10) d = "0" + d;
      return y + "-" + m + "-" + d;
    },
    getChildabels(id) {
      if (id) {
        getChildabels({
          childUid: id
        }).then(res => {
          if (res.msgCode == 200) {
            this.labelsList = res.responseData
            // 特殊患儿不显示 zh-20211101
            // this.labelsList=this.labelsList.filter(i=>i!='特殊患儿');
          }
        })
      }
    },
    msgCodeValue(text) {
      this.dialogForm.captcha = text;
    },
    // 发送患儿注册验证码
    sendCode() {
      if (this.codeFlag) {
        return false;
      }
      this.codeFlag = true;
      let params = {
        phone: this.dialogForm.loginAccount,
      };
      sendCaptchaApi(params).then((res) => {
        if (res.msgCode == 200) {
          this.codeText = this.countDown + "s重新发送";
          var timer = setInterval(() => {
            this.countDown--;
            this.codeText = this.countDown + "s重新发送";
            if (this.countDown == 0) {
              this.codeFlag = false;
              clearInterval(timer);
              this.countDown = 60;
              this.codeText = "获取验证码";
            }
          }, 1000);
        } else {
          this.$message.error(res.msga);
          this.codeFlag = false;
        }
      })
      .catch((this.codeFlag = false));
    },
    queryDetail(id) {
      getChildInfo({
        helpId: id,
      }).then((res) => {
        this.info = res.responseData;
        this.queryList(this.info.childUid);
        this.info.guardIdNumber = this.info.guardIdNumber ? this.info.guardIdNumber : "-";
        this.info.guardWechat = this.info.guardWechat ? this.info.guardWechat : "-";
        this.info.idNumber = this.info.hasIdNumber == 1 ? this.info.idNumber : "-";
        if (this.info.birthday) {
          this.birthday = this.makeDate(parseInt(this.info.birthday));
        }
        if (this.info.portrait) {
          let param = [this.info.portrait];
          getFileListByIds(param).then((res1) => {
            this.childAvatar = res1.responseData[0].fileUrl;
          });
        } else {
          this.childAvatar = "/static/default-avatar.png";
        }
      });
    },
    formatDate(row, colum) {
      var date = row[colum.property];
      if (date === undefined) {
        return "-";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    queryList(id) {
      let param = {
        searchCond: {
          childUid: id, //患儿姓名
          publishStatus: 2
          // helpStatus: 1,
        },
        orderBy: "createAt desc",
        pageNO: "",
        pageSize: "",
      };
      getOutlayListByCondNoPaging(param).then((res) => {
        this.tableData = res.responseData.modelData;
        let angleList = this.tableData.filter(dat => {
          return dat.initialProject == 'AY1002' && dat.outlayId;
        });
        if (angleList && angleList.length > 0) {
          this.totalAngleOutlayAmount(angleList[0]);
        }
      });
    },
    totalAngleOutlayAmount (outlay) {
      getAngleRemainingAmountByReqId({
        helpReqId: outlay.helpReqId
      }).then(res => {
        if (res.msgCode == 200) {
          this.hospitalMoneyInfo.totalAngleOutlayAmount = parseFloat(res.responseData.helpAmount || 0).toFixed(2);
          this.hospitalMoneyInfo.allowAngelOutlay = res.responseData.allowAngelOutlay;
          this.$forceUpdate();
        }
      });
    },
    openOutlayDialog (row) {
      this.outlayRowData = row;
      this.outlayDetailVisible = true;
      this.dialogVisible = true;
      this.dialogActiveName = 'outlayInfo';
    },

    openNewDialog() {
      this.newDialog = true;
    },
    openFqDialog(obj) {
      this.newFqData = obj;
      this.fqDialog = true;
    },
    closeNewRequest() {
      this.newRequestDialog = false;
    },
    newRequstCommited() {
      this.newRequestDialog = false;
      this.newDialog = false;
      this.queryList(this.$route.query.uid);
    },
    openNewRequest() {
      this.newRequestData = this.info;
      this.newRequestData.other = {
        hospitalId: this.dialogForm.hospitalId,
        diseasesList: this.dialogForm.diseasesList,
        disease: this.disease,
        quotaType: this.dialogForm.quotaType,
        totalStages: this.dialogForm.totalStages,
      };
      this.newRequestDialog = true;
    },
    openMoneyInputDialog(obj) {
      this.choosehelpReqId = obj.helpReqId;
      this.newFqData = obj;
      this.moneyInputDialog = true;
    },
    openAgreeDialog(row) {
      this.proId = row.protocolId;
      if (row.applyType > 1) {
        this.$router.push('/child/refund/' + row.protocolId + '/' + row.applyType + '/' + row.applyId + '/y');
      } else {
        this.$router.push({
          path: '/protocol/detail/' + row.protocolId
        })
      }
    },
    openDetail(obj) {
      this.chooseHelpId = obj.helpId;
      this.chooseData = obj;
      this.outlayId = obj.outlayId;
      this.detailJzDialog = true;
    },
    // 选择病种
    changeDisease(e) {
      console.log(e);
      let _list = [];
      e.forEach((item) => {
        let _item = {
          diseasesId: item[2],
        };
        _list.push(_item);
      });
      this.dialogForm.diseasesList = _list;
      console.log(this.dialogForm);
    },
    getHosp(e) {
      this.getGrantedDiseasesTree(e);
    },
    // 病种树状列表
    getGrantedDiseasesTree(id) {
      let params = {
        hospitalId: id,
      };
      getGrantedDiseasesTreeApi(params)
        .then((res) => {
          if (res.msgCode == 200) {
            this.diseaseOptions = res.responseData;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
@import "src/common/form";
@import "src/common/dialog";

/deep/ .applyTable .el-table__body .el-table__row {
  height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/child/view/ChildDetail.vue